export class TimeSheet{

    id: number;
    time_added: any;//number;
    effort_time_left: number;
    time_to_date: any;
    description:string;
   
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/models/time-sheet.ts